import './OrderList.css';

import { IonContent, IonPage } from '@ionic/react';
import { useEffect, useState } from 'react';

import LoadingContainer from '../../../../components/loading/LoadingContainer';
import LayoutGap from '../../../../layouts/LayoutGap';
import Toolbar from '../../../../layouts/Toolbar';
import { OrderListGetAction } from '../../../../redux/actions/Account'
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import ListItem from '../../../../components/list/ListItem';
import { Empty } from '../../../../layouts/errors/Empty';
import { bagHandleOutline } from 'ionicons/icons';

const OrderList: React.FC = () => {
    const dispatch = useAppDispatch()

    const { loading, orders } = useAppSelector(state => state.orderListReducer)

    useEffect(() => {
        dispatch(OrderListGetAction())
    }, [dispatch])

    return <LoadingContainer loading={loading}>
        <IonPage>
            <Toolbar title="سفارش ها" hasBackButton />

            <LayoutGap />

            <IonContent className="order-list main-content">
                <Empty text="سفارشی وجود ندارد!" icon={bagHandleOutline} length={orders.orders?.length}>
                    {orders.orders?.map((item: any) => {
                        let status = "";
                        let color = "";

                        switch (item.status) {
                            case "PAID": color = "warning"; status = "پرداخت شده"; break;
                            case "PREPARING": color = "info"; status = "در حال آماده سازی"; break;
                            case "CONFIRMED": color = "info"; status = "تایید شده"; break;
                            case "SENT": color = "success"; status = "ارسال شده"; break;
                            case "CANCELED": color = "danger"; status = "لغو شده"; break;
                            case "RETURNED": color = "danger"; status = "مرجوع شده"; break;
                        }

                        return <ListItem title={item.id} value={item.total_price} valueText="مبلغ سفارش" status={status} date={item.date} dateTitle="تاریخ سفارش" color={color} link={`/account/orders/${item.id}`} />
                    })}
                </Empty>
            </IonContent>
        </IonPage>
    </LoadingContainer>
}

export default OrderList